<template>
  <el-dialog
    width="60%"
    :visible.sync="dialogVisible"
    custom-class="message-carousel"
    @close="handleClose"
  >
    <el-carousel
      ref="carousel"
      arrow="always"
      :autoplay="false"
      :loop="false"
      indicator-position="none"
      @change="handleChange"
    >
      <el-carousel-item v-for="(item, index) in data" :key="item.id">
        <message-detail
          ref="MessageDeatil"
          :data="item"
          :showTitle="true"
          :indexData="{
            index: index + 1,
            total: data.length,
          }"
          @next="handleNext"
        />
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
</template>

<script>
import MessageDetail from './MessageDetail.vue'
import { pushLXModuleClick } from '../../utils'

export default {
  name: 'MessageCarousel',
  components: {
    MessageDetail,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      timer: null,
      activeIdx: 0,
      cid: 'c_mobikeops_8fa4un26',
      closeModuleClickFlag: true,
    }
  },
  computed: {
    misId() {
      return window.__BIKE_POLARIS__.mis
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
      // 轮询判断 window.__BIKE_POLARIS__.mis 是否存在，避免上报埋点中mis号为空
      this.timer = setInterval(() => {
        if (window.__BIKE_POLARIS__.mis) {
          clearInterval(this.timer)
          this.handleChange(0, 0)
        }
      }, 1000)
    },

    async handleChange(activeIdx, preIdx) {
      this.activeIdx = activeIdx
      if (activeIdx < preIdx) return
      this.$nextTick(() => {
        this.$refs.MessageDeatil &&
        this.$refs.MessageDeatil[activeIdx] &&
        this.$refs.MessageDeatil[activeIdx].receipt()
      })
    },

    handleClose() {
      const msg = this.data[this.activeIdx] || {}
      if (this.closeModuleClickFlag && msg.templateId) {
        pushLXModuleClick('b_mobikeops_47bq8n75_mc', this.cid, this.misId, {
          title: msg.title,
          topic_id: msg.templateId,
        })
      }
    },

    // 点击我已知晓自动切换到下一条消息, 若为最后一条则关闭弹窗
    handleNext() {
      this.closeModuleClickFlag = false // 自动关闭不埋点
      this.$refs.carousel.next()
      if (this.activeIdx === this.data.length - 1) {
        this.dialogVisible = false
      }
    }
  },
}
</script>

<style lang="scss">
.message-carousel {
  position: relative;
  min-width: 600px;
  .el-dialog__header {
    border-bottom: none !important;
  }
  .el-dialog__body {
    .el-carousel__container {
      height: 500px;
      .el-carousel__item {
        overflow: auto;
      }
      .message-detail-form {
        padding: 0 80px;
      }
    }
  }
}
</style>
